import {
  TOGGLE_SIDEBAR_VISIBILITY
} from '@/store/mutation-types'

const getDefaultState = () => {
  return {
    isSidebarVisible: true
  }
}

const state = getDefaultState()

const mutations = {
  [TOGGLE_SIDEBAR_VISIBILITY] (state) {
    // We need to displace the router-container that has margins and prevents fullwidth content
    const routerContainer = document.getElementById('router-container')
    routerContainer.classList.toggle('slideout-panel-hidden')
  }
}

export default () => ({
  namespaced: true,
  state,
  mutations
})
